(function ($, Drupal) {

  Drupal.behaviors.mobMenu = {
    attach: function () {
      let $btn = $('.mob-menu');

      if ($btn.length > 0) {
        $btn.on('click', function () {
          $('html, body, .page').toggleClass('locked');
        })
      };

      let $fontSize;

      if (sessionStorage.getItem('fontSize')) {
        $fontSize = parseInt(sessionStorage.getItem('fontSize'));

      } else {
        $fontSize = 16;
      }

      if (sessionStorage.getItem('dark') == 'true') {
        $('html').addClass('dark');
      } else {
        $('html').removeClass('dark');
      }

      $('html').css('fontSize', $fontSize);

      $('.controller.size.plus').on('click', function () {
        if ($fontSize <= 29) {
          $fontSize++;
          $('html').css('fontSize', $fontSize);
          $(this).removeClass('disabled');
          $('.controller.size.minus').removeClass('disabled');
        } else {
          $(this).addClass('disabled');
        };

        sessionStorage.setItem('fontSize', $fontSize);
      });

      $('.controller.size.minus').on('click', function () {
        if ($fontSize >= 11) {
          $fontSize--;
          $('html').css('fontSize', $fontSize);
          $(this).removeClass('disabled');
          $('.controller.size.plus').removeClass('disabled');
        } else {
          $(this).addClass('disabled');
        };

        sessionStorage.setItem('fontSize', $fontSize);
      });

      $('.controller.contrast').on('click', function () {
        $('html').toggleClass('dark');
        if (sessionStorage.getItem('dark') == 'true') {
          sessionStorage.setItem('dark', false);
        } else {
          sessionStorage.setItem('dark', true);
        }
      })
    }
  }
}(jQuery, Drupal));
